import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import LogoBlack from '../../assets/img/logo-black-revised.png';
import LogoWhite from '../../assets/img/logo-white.png';
import Arrow from '../../assets/img/arrow.svg';
import {Header, HeaderWrapper, Logo, MenuButton, NavListWrapper, NavList, NavListItem} from './styles-global';

const showMenu = () => {
	const menu = document.querySelector('#nav');
    menu.classList.toggle('show')
};

const AppHeader = () => {
	const location = useLocation();
	const logo = location.pathname.startsWith('/impact') ? LogoWhite : LogoBlack;
	return (
		<Header>
			<div className="container">
				<HeaderWrapper>
					<Logo>
						<Link to="/" tabIndex="0">
							<img src={logo} alt="Project SafeUp Logo" />
						</Link>
					</Logo>
					<MenuButton onClick={showMenu}>
						<img src="assets/icons/menu-button.svg" alt="Menu Button" />
					</MenuButton>
					<NavListWrapper id="nav" role="navigation">
						<NavList>
							<NavListItem>
								<Link to="/" tabIndex="0" className="nav-list--item">
									<span onClick={() => window.location.replace('/#testimonials')}>Testimonials</span>
								</Link>
							</NavListItem>
							<NavListItem>
								<Link to="/" tabIndex="0" className="nav-list--item">
									<span onClick={() => window.location.replace('/#team')}>Team</span>
								</Link>
							</NavListItem>
							<NavListItem>
								<Link to="/impact" tabIndex="0" className="nav-list--item-main">
									Impact Story
									<img src={Arrow} alt="Go to Our Impact Story" />
								</Link>
							</NavListItem>
						</NavList>
					</NavListWrapper>
				</HeaderWrapper>
			</div>
		</Header>
	);
};

export default AppHeader;
